module.exports = __webpack_public_path__ + "media/images/icon/icons8-Browser Window-89bdbfbe617d5c9cc72810532058aeb5.png";